import { render, staticRenderFns } from "./bnr-shipmate.vue?vue&type=template&id=1b3ec1d8&scoped=true"
import script from "./bnr-shipmate.vue?vue&type=script&lang=js"
export * from "./bnr-shipmate.vue?vue&type=script&lang=js"
import style0 from "./bnr-shipmate.vue?vue&type=style&index=0&id=1b3ec1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ec1d8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
